export const SOB_COMPETITORS = 'jbp-sob-competitors'

export const TRANSLATION_KEYS = {
  chartName: `${SOB_COMPETITORS}--chart-name`,
  sobTitle: `${SOB_COMPETITORS}--sob-title`,
  yoyTitle: `${SOB_COMPETITORS}--yoy-title`,
  qoqTitle: `${SOB_COMPETITORS}--qoq-title`,
  sellThruTitle: `${SOB_COMPETITORS}--sell-thru-title`,
  warningText: `${SOB_COMPETITORS}--warning-text`,
  selectCompetitors: `${SOB_COMPETITORS}--select-competitors`,
  sellThruSwitch: `${SOB_COMPETITORS}--sell-thru-switch`,

  comment: `${SOB_COMPETITORS}--comment`,

  hasChanges: `${SOB_COMPETITORS}--has-changes`,
  table: {
    columns: {
      FY: `${SOB_COMPETITORS}--fy-title`,
      Q1: `${SOB_COMPETITORS}--q1-column-title`,
      Q1YOY: `${SOB_COMPETITORS}--q1-column-title-yoy`,
      Q2: `${SOB_COMPETITORS}--q2-column-title`,
      Q2YOY: `${SOB_COMPETITORS}--q2-column-title-yoy`,
      Q3: `${SOB_COMPETITORS}--q3-column-title`,
      Q3YOY: `${SOB_COMPETITORS}--q3-column-title-yoy`,
      Q4: `${SOB_COMPETITORS}--q4-column-title`,
      Q4YOY: `${SOB_COMPETITORS}--q4-column-title-yoy`,
      total: `${SOB_COMPETITORS}--total-column-title`,
      totalUpToDate: `${SOB_COMPETITORS}--total-up-to-date-column-title`,
    },
  },
  warning: {
    important: `${SOB_COMPETITORS}--warning-important`,
    importantComment: `${SOB_COMPETITORS}--warning-important-comment`,
    secondText: `${SOB_COMPETITORS}--warning-second-text`,
    secondTextHighlighted: `${SOB_COMPETITORS}--warning-second-text-highlighted`,
    thirdText: `${SOB_COMPETITORS}--warning-third-text`,
    thirdTextHighlighted: `${SOB_COMPETITORS}--warning-third-text-highlighted`,
    fourText: `${SOB_COMPETITORS}--warning-four-text`,
    fourTextHighlighted: `${SOB_COMPETITORS}--warning-four-text-highlighted`,
    fiveText: `${SOB_COMPETITORS}--warning-five-text`,
    sixText: `${SOB_COMPETITORS}--warning-six-text`,
  },
  confirmDeleteCompetitorDialog: {
    title: `${SOB_COMPETITORS}--confirm-delete-competitor-dialog--title`,
    text: `${SOB_COMPETITORS}--confirm-delete-competitor-dialog--text`,
    confirm: `${SOB_COMPETITORS}--confirm-delete-competitor-dialog--confirm`,
    cancel: `${SOB_COMPETITORS}--confirm-delete-competitor-dialog--cancel`,
  },
}
